import { render, staticRenderFns } from "./NoOfferNotifier.vue?vue&type=template&id=68ab3970&scoped=true"
import script from "./NoOfferNotifier.vue?vue&type=script&lang=ts"
export * from "./NoOfferNotifier.vue?vue&type=script&lang=ts"
import style0 from "./NoOfferNotifier.vue?vue&type=style&index=0&id=68ab3970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab3970",
  null
  
)

export default component.exports